import UrlResolver from '@core/url-resolver/UrlResolver';
import useAlgoliaFakeQuery from '@hooks/useAlgoliaFakeQuery';
import * as React from 'react';
import S from './SearchTypeahead.styles';

export type SearchTypeaheadProps = {
  visible: boolean;
  hasSearchTerm: boolean;
  results: ProductViewModel[];
  cultureCode: string;
  searchTerm: string;
  algoliaEnvironmentPrefix: string | null;
};

const SearchTypeahead: React.FC<SearchTypeaheadProps> = ({
  visible,
  hasSearchTerm,
  results,
  cultureCode,
  searchTerm,
  algoliaEnvironmentPrefix,
}) => {
  useAlgoliaFakeQuery(cultureCode, searchTerm, algoliaEnvironmentPrefix);

  if (results.length === 0 || !hasSearchTerm) {
    return null;
  }

  return (
    <S.Container aria-current={visible}>
      <S.Inner>
        <S.List>
          {results.map((result) => (
            <S.Item key={result.articleNumber}>
              <S.Link href={result.url}>
                <S.ImageWrapper>
                  <img src={UrlResolver.formatImageUrl(result.listingImage, 150)} alt={result.title} />
                </S.ImageWrapper>
                <S.Content>
                  <S.ModelCode>{result.modelCode}</S.ModelCode>
                  <S.Name>{result.title}</S.Name>
                </S.Content>
              </S.Link>
            </S.Item>
          ))}
        </S.List>
      </S.Inner>
    </S.Container>
  );
};

export default SearchTypeahead;
